import React, { FCWithChildren } from 'react';
import Button, { ButtonProps } from '@components/atoms/button/button';
import { useContextSelector } from 'use-context-selector';
import { ModalContext } from '@context/modal.context';
import { Product } from '@interfaces/models/product';
import dynamic from 'next/dynamic';

const SizeGuideModal = dynamic(() => import('./components/size-guide-modal/size-guide-modal'), {
  ssr: false,
});

export type SizeGuideWrapperProps = {
  universeId: Product['universe']['id'];
  productCategoryId: Product['category']['id'];
  sizeGuideStandard: Product['size']['standard'];
  sizeGuideSize?: Product['size']['size'];
} & ButtonProps;

const SizeGuideWrapper: FCWithChildren<SizeGuideWrapperProps> = (props) => {
  const { universeId, productCategoryId, sizeGuideSize, sizeGuideStandard, children, ...rest } = props;

  const openModal = useContextSelector(ModalContext, (v) => v.openModal);

  const openSizeGuideModal = () =>
    openModal((modalDialogTitleId) => (
      <SizeGuideModal
        universeId={universeId}
        productCategoryId={productCategoryId}
        sizeGuideStandard={sizeGuideStandard}
        sizeGuideSize={sizeGuideSize}
        modalDialogTitleId={modalDialogTitleId}
      />
    ));

  return (
    <Button
      data-cy="open-size-guide-modal-button"
      data-vc-dd-action-name="size_guide_modal_button"
      aria-hidden="true"
      disableDefaultStyling
      onClick={openSizeGuideModal}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default SizeGuideWrapper;
